import styled, { css } from "styled-components";
import theme from "../../../Styles/theme";

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface ContainerProps {
  interactive?: boolean;
}

export const MunicipioContainer = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  ${({ interactive }) =>
    interactive &&
    css`
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    `}
`;

export const Title = styled.span`
  color: ${theme.colors.dark};
  font-size: 10px;
  text-align:justify;
`;

export const MunicipioLogo = styled.img`
  width: 60px;
  height: 60px;
`;

export const GuiaContainer = styled.div<ContainerProps>`
  border: solid 1px ${theme.colors.dark};
  display: flex;
  align-items: center;
  justify-content: space-around;

  padding: 1.4vh 2vw;
  ${({ interactive }) =>
    interactive &&
    css`
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    `}
`;

export const GuiaTitle = styled.label`
  color: ${theme.colors.dark};
  font-size: 11px;
  font-weight: bold;
  margin-right: 1vw;
`;

export const GuiaInput = styled.span`
  color: ${theme.colors.dark};
  font-size: 11px;
  font-weight: bold;
  border: none;
`;
